import { DollarSign, Users, Receipt, Building2, BookOpen, ArrowRight } from "lucide-react";

const services = [
  {
    icon: DollarSign,
    title: "Payroll",
    description: "Comprehensive payroll management for businesses of all sizes. We handle PAYE, RTI submissions, pension auto-enrolment, and monthly payslips — so you can focus on running your business.",
    color: "purple",
  },
  {
    icon: Users,
    title: "Sole Traders & Partnerships",
    description: "Expert self-assessment tax returns, accounts preparation, and business advice for sole traders and partnerships. We'll ensure you're compliant and tax-efficient.",
    color: "violet",
  },
  {
    icon: Receipt,
    title: "VAT Returns",
    description: "Accurate and timely VAT return preparation and submission. We'll manage your VAT obligations, handle HMRC correspondence, and advise on VAT planning opportunities.",
    color: "fuchsia",
  },
  {
    icon: Building2,
    title: "Limited Companies",
    description: "Full company accounts preparation, corporation tax returns, confirmation statements, and director self-assessments. Everything your limited company needs in one place.",
    color: "purple",
  },
  {
    icon: BookOpen,
    title: "Bookkeeping",
    description: "Reliable monthly or quarterly bookkeeping services to keep your finances in order. We use industry-leading software to give you real-time financial clarity.",
    color: "violet",
  },
];

const colorMap = {
  purple: {
    bg: "bg-purple-50",
    icon: "bg-purple-100 text-purple-600",
    hover: "hover:border-purple-300",
    badge: "bg-purple-600",
  },
  violet: {
    bg: "bg-violet-50",
    icon: "bg-violet-100 text-violet-600",
    hover: "hover:border-violet-300",
    badge: "bg-violet-600",
  },
  fuchsia: {
    bg: "bg-fuchsia-50",
    icon: "bg-fuchsia-100 text-fuchsia-600",
    hover: "hover:border-fuchsia-300",
    badge: "bg-fuchsia-600",
  },
};

export default function Services({ onServiceClick }) {
  return (
    <section id="services" className="py-24 bg-slate-50">
      <div className="max-w-6xl mx-auto px-6">
        
        <div className="text-center mb-16">
          <div className="text-purple-600 text-sm font-semibold tracking-widest uppercase mb-3">
            What We Offer
          </div>
          <h2 className="text-4xl font-bold text-slate-800 mb-4">
            Our Services
          </h2>
          <p className="text-slate-500 text-lg max-w-2xl mx-auto">
            From day-to-day bookkeeping to complex company accounts, we provide a full range of accountancy services tailored to your needs.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service) => {
            const c = colorMap[service.color];
            const Icon = service.icon;

            return (
              <div
                key={service.title}
                className={`group bg-white rounded-2xl p-8 border border-slate-200 ${c.hover} transition-all duration-300 hover:shadow-xl hover:-translate-y-1 cursor-pointer`}
                onClick={() => onServiceClick(service.title)}
              >
                <div className={`w-14 h-14 rounded-2xl ${c.icon} flex items-center justify-center mb-6`}>
                  <Icon size={24} />
                </div>

                <h3 className="text-xl font-bold text-slate-800 mb-3">
                  {service.title}
                </h3>

                <p className="text-slate-500 leading-relaxed mb-6">
                  {service.description}
                </p>

                <div className="flex items-center gap-2 text-purple-600 font-semibold text-sm group-hover:gap-3 transition-all">
                  <span>Get in touch</span>
                  <ArrowRight size={16} />
                </div>
              </div>
            );
          })}
        </div>

      </div>
    </section>
  );
}